import { EventBus } from "@/common/utils/event-bus";

export const state = {
    version: '1.0.0',
    pageModel: {},
}

export const mutations = {
    SET_PAGE_MODEL(state, model) {
        state.pageModel = model;
    }
}

export const getters = {
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
